import { defineComponent as a, ref as i, createBlock as u, openBlock as s, withCtx as d, createVNode as p, unref as f } from "vue";
import { ScalarTextInput as c } from "@scalar/components";
import v from "./SidebarListElementForm.vue.js";
const C = /* @__PURE__ */ a({
  __name: "EditSidebarListElement",
  props: {
    name: {}
  },
  emits: ["close", "edit"],
  setup(m, { emit: l }) {
    const r = m, n = l, t = i(r.name);
    return (x, e) => (s(), u(v, {
      onCancel: e[1] || (e[1] = (o) => n("close")),
      onSubmit: e[2] || (e[2] = (o) => n("edit", t.value))
    }, {
      default: d(() => [
        p(f(c), {
          modelValue: t.value,
          "onUpdate:modelValue": e[0] || (e[0] = (o) => t.value = o),
          autofocus: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }));
  }
});
export {
  C as default
};
